import { useMemo, useEffect } from "react";
import { Box } from "@mui/material";
import { useFormContext } from "react-hook-form";
import SelectFacebookPageWithConnect from "../../../../Meta/SelectFacebookPageWithConnect";
import Select from "../../../../Form/Select";
import { getExtensionFile } from "../../../../../utils/string";
import {
  IMAGE_FORMATS,
  FACEBOOK_IMAGE_CONTENT_TYPE_OPTIONS,
  FACEBOOK_VIDEO_CONTENT_TYPE_OPTIONS,
  VIDEO_FORMATS,
  FACEBOOK_CONTENT_TYPE_CAROUSEL,
} from "../../../../../utils/constants";
import {
  FIELD_REQUIRED,
  PAGE_FACEBOOK_PLACEHOLDER,
  TYPE_CONTENT_FACEBOOK_LABEL,
} from "../../../../../i18n/keysTranslations";

const FacebookPlatformFields = ({
  control,
  errors,
  currentItem,
  t,
  uniqueFacebookPagesList = [],
  isCarouselMode = false,
  currentItems = [],
  onContentTypeChange,
}) => {
  const { setValue, watch } = useFormContext();
  const format = getExtensionFile(currentItem?.url);
  const isImage = IMAGE_FORMATS.includes(format);
  const isVideo = VIDEO_FORMATS.includes(format);
  const currentContentType = watch("platformsData.facebook.contentType");

  const isMultiImageCarousel = isCarouselMode && currentItems.length >= 2;
  const restrictToCarouselOnly = isMultiImageCarousel;

  const contentTypeOptions = useMemo(() => {
    if (!currentItem?.url) return [];

    let options = [];
    if (isImage) {
      const mapped = FACEBOOK_IMAGE_CONTENT_TYPE_OPTIONS.map((option) => ({
        value: option.value,
        label: t(option.labelKey),
      }));
      options = restrictToCarouselOnly
        ? mapped.filter(
            (option) => option.value === FACEBOOK_CONTENT_TYPE_CAROUSEL
          )
        : mapped;
    }

    if (isVideo) {
      options = FACEBOOK_VIDEO_CONTENT_TYPE_OPTIONS.map((option) => ({
        value: option.value,
        label: t(option.labelKey),
      }));
    }
    return options;
  }, [currentItem?.url, isImage, isVideo, restrictToCarouselOnly, t]);

  useEffect(() => {
    if (contentTypeOptions.length === 0) return;
    const isStillValid = contentTypeOptions.some(
      (opt) => opt.value === currentContentType
    );
    if (currentContentType && !isStillValid) {
      setValue(
        "platformsData.facebook.contentType",
        contentTypeOptions[0].value
      );
    }
  }, [contentTypeOptions, currentContentType, setValue]);

  useEffect(() => {
    if (isCarouselMode && currentItems.length >= 2 && !currentContentType) {
      const hasCarouselOption = contentTypeOptions.some(
        (opt) => opt.value === FACEBOOK_CONTENT_TYPE_CAROUSEL
      );
      if (hasCarouselOption) {
        setValue(
          "platformsData.facebook.contentType",
          FACEBOOK_CONTENT_TYPE_CAROUSEL
        );
      }
    }
  }, [
    isCarouselMode,
    currentItems.length,
    contentTypeOptions,
    setValue,
    currentContentType,
  ]);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <SelectFacebookPageWithConnect
        variant="filled"
        name="platformsData.facebook.account"
        label={t(PAGE_FACEBOOK_PLACEHOLDER)}
        fullWidth
        control={control}
        errors={errors}
        uniqueFacebookPagesList={uniqueFacebookPagesList}
        rules={{
          required: {
            value: true,
            message: t(FIELD_REQUIRED),
          },
        }}
      />

      <Select
        variant="filled"
        name="platformsData.facebook.contentType"
        label={t(TYPE_CONTENT_FACEBOOK_LABEL)}
        options={contentTypeOptions}
        fullWidth
        control={control}
        errors={errors}
        disabled={!currentItem?.url}
        validationChange={(value) => {
          if (onContentTypeChange) {
            return onContentTypeChange("facebook", value);
          }
          return true;
        }}
        rules={{
          required: {
            value: true,
            message: t(FIELD_REQUIRED),
          },
        }}
      />
    </Box>
  );
};

export default FacebookPlatformFields;
